module.exports = __webpack_public_path__ + "reviews-row-update1.png";